<template>
  <div :class="$style.container">
    <payment-template>
      <base-header
        slot="header"
        :title="$t('something.wrong')"
        :language="getLanguage"
      />
      <template #content>
        <transaction-card-template
          :title="$t('save.transaction.number')"
          :payment-id="getDisplayPaymentId"
        >
          <div :class="$style.section">
            <div :class="$style.row">
              <div :class="$style.left">{{ $t('transaction.date') }}</div>
              <div :class="$style.right">{{ getFormattedPaymentDate }}</div>
            </div>
            <div :class="$style.row">
              <div :class="$style.left">{{ $t('transaction.sum') }}</div>
              <div :class="$style.right">{{ getDisplayAmount }}</div>
            </div>
            <div :class="$style.row">
              <div :class="$style.left">{{ $t('transaction.recipient') }}</div>
              <div :class="$style.right">
                <div :class="$style.project">{{ getDisplayProjectName }}</div>
                <base-link :href="`mailto:${getDisplayMerchantEmail}`">
                  {{ getDisplayMerchantEmail }}
                </base-link>
              </div>
            </div>
          </div>
        </transaction-card-template>

        <div v-if="isShownButton" :class="$style.button">
          <simple-button variant="secondary" @click="handleRedirect">
            {{ $t('return.to.site') }}
          </simple-button>
        </div>
      </template>

      <base-footer slot="footer" security />
    </payment-template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import BaseLink from 'atoms/base/BaseLink';
import BaseFooter from 'molecules/base/BaseFooter';
import BaseHeader from 'organisms/base/BaseHeader';

import SimpleButton from 'molecules/common/SimpleButton';

import PaymentTemplate from 'templates/PaymentTemplate';
import TransactionCardTemplate from 'templates/TransactionCardTemplate';

export default {
  name: 'ExpiredPayment',
  components: {
    BaseLink,
    BaseFooter,
    BaseHeader,
    SimpleButton,
    PaymentTemplate,
    TransactionCardTemplate,
  },
  computed: {
    isShownButton() {
      return this.getFailUrl || this.getProjectUrl;
    },
    ...mapState(['PROJECT']),
    ...mapGetters([
      'getLanguage',
      'getDisplayPaymentId',
      'getFormattedPaymentDate',
      'getDisplayAmount',
      'getDisplayProjectName',
      'getDisplayMerchantEmail',
      'getFailUrl',
      'getProjectUrl',
    ]),
  },
  methods: {
    handleRedirect() {
      if (this.getFailUrl) {
        window.location.assign(this.getFailUrl);
        return;
      }

      window.location.assign(this.getProjectUrl);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +respond-to('medium')
      padding: 10px 0

  .section
    display: flex
    flex-direction: column

  .row
    display: flex

    &:not(:last-child)
      margin-bottom: 15px

  .left, .right
    width: 50%

  .left
    color: rgba(33, 33, 33, 0.75)

  .project
    word-break: break-all
    color: rgba(155, 81, 224, 1)

  .button
    margin-top: 30px
</style>
